<template>
  <div class="flex w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/5 content-center min-w-card">
    <div class="card bg-white">
      <div class="card-content text-center">
        <div class="flex-item">
          <div class="icon icon--large mb-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="23"
              height="22"
              viewBox="0 0 23 22"
            >
              <g fill-rule="evenodd">
                <path d="M.522 8.348h.521V21.39c0 .288.234.522.522.522h19.826a.522.522 0 0 0 .522-.522V8.348h.522a.522.522 0 0 0 .522-.522v-3.13c0-.007-.004-.01-.004-.017 0-.033-.012-.066-.02-.1-.008-.035-.012-.07-.027-.102l-.004-.016L20.815.287A.526.526 0 0 0 20.348 0H2.608a.523.523 0 0 0-.466.288L.055 4.462c-.003.005-.002.01-.004.016-.014.032-.02.066-.028.102-.007.033-.019.066-.02.099 0 .006-.003.01-.003.017v3.13c0 .288.234.522.522.522zM20.87 20.87H2.087V8.348H20.87V20.87zm1.043-13.566H1.043V5.217h20.87v2.087zM2.931 1.044h17.095l1.566 3.13H1.366l1.565-3.13z" />
                <path
                  stroke="#231F20"
                  stroke-width=".15"
                  d="M7.826 15.652h7.304a.522.522 0 0 0 .522-.522V12a.522.522 0 0 0-.522-.522H7.826a.522.522 0 0 0-.522.522v3.13c0 .288.234.522.522.522zm.522-3.13h6.26v2.087h-6.26v-2.087z"
                />
              </g>
            </svg>
          </div>
          <h3 class="mb-1">
            <a
              href="#"
              v-html="itemTitle"
            />
          </h3>
          <h5
            class="mt-0 mb-4 uppercase"
            v-text="`${itemCount} Documents`"
          />
          <div class="flex justify-between">
            <a
              class="btn btn--sm btn--border"
              href="#"
              @click.prevent="approveSharedItem"
              v-text="'Approve'"
            />
            <a
              class="btn btn--sm btn--danger"
              href="#"
              @click.prevent="openRejectSharedItemModal"
              v-text="'Delete'"
            />
          </div>
        </div>
      </div>
      <footer class="card-footer">
        <img
          :src="ownerLogo"
          alt=""
          class="rounded-full w-8 h-8"
        >
        <h6 v-text="`Shared: ${shareDate} By`" />
        <p v-text="sharedBy" />
      </footer>
    </div>
  </div>
</template>

<script type="text/babel">
export default {
  name: 'PendingFolderShare',
  props: {
    pendingShare: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: true,
    }
  },
  computed: {
    ownerLogo() {
      return this.pendingShare.owner.attributes.logo
    },
    itemCount() {
      return this.pendingShare.item._type === 'Folder'
        ? this.pendingShare.item.attributes.item_count
        : null
    },
    itemTitle() {
      return this.pendingShare.item._type === 'Folder'
        ? this.pendingShare.item.attributes.title
        : ''
    },
    shareDate() {
      return this.$date.toMomentDateFormat(this.pendingShare.attributes.created_at)
    },
    sharedBy() {
      return this.pendingShare.owner.attributes.name
    },
  },
  methods: {
    approveSharedItem() {
      this.loading = true

      this.$api.active().put(`shares/${this.pendingShare.uuid}/accept`)
        .then(() => {
          this.loading = false

          this.$store.commit('baseAddNotification', {
            type: 'success',
            title: 'Success',
            text: 'Shared item has been approved.',
          })

          this.$emit('sharedItemHasBeenApproved')
        })
    },
    openRejectSharedItemModal() {
      this.$store.commit('documentOpenRejectSharedItemModal', this.pendingShare)
    },
  },
}
</script>
